module.exports = __webpack_public_path__ + "static/media/Camera04.27823051.jpg";